<template>
  <div :class="componentClassName">
    <a-page-heading>営業時間設定 </a-page-heading>
    <m-section variant="fullpage">
      <m-action-card title="特別営業日設定" icon="calendar" :narrow-body="true">
        <form
          ref="form"
          class="t-setting-business-hours-edit-hours-on-holiday__form"
          @submit.prevent="handleFormSubmit"
        >
          <div class="t-setting-business-hours-edit-hours-on-holiday__fields">
            <o-special-business-day-setting-list v-model="currentHoursList" />
            <m-form-action-buttons>
              <a-button variant="block" color="primary" submit="submit">保存</a-button>
              <a-button variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button>
            </m-form-action-buttons>
          </div>
        </form>
      </m-action-card>
    </m-section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MSection from '@/components/molecules/section';
import OSpecialBusinessDaySettingList from '@/components/organisms/special-business-day-setting-list';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AButton from '@/components/atoms/button';
import { cloneDeep } from 'lodash';

export default {
  name: 't-setting-business-hours-edit-hours-on-holiday',
  components: {
    APageHeading,
    MActionCard,
    MSection,
    OSpecialBusinessDaySettingList,
    MFormActionButtons,
    AButton,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    hoursList: {
      type: Array,
      default: new Array(0),
    },
    handleCancelClick: {
      type: Function,
      default: () => {},
    },
    handleSaveClick: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentHoursList: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-business-hours-edit-hours-on-holiday');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    hoursList: {
      handler(val) {
        this.currentHoursList = val;
      },
      deep: true,
    },
  },
  mounted() {
    this.currentHoursList = this.hoursList;
  },
  methods: {
    handleFormSubmit(e) {
      e.preventDefault();
      const payload = cloneDeep(this.currentHoursList);
      this.handleSaveClick(payload);
    },
  },
};
</script>
